export function MetricCard({ label, value, classNameLabel, classNameValue }) {
  return (
    <article className="p-3 mb-3 bg-white rounded-lg border border-solid border-stone-200 max-sm:mb-2">
      <div className="flex justify-between items-center">
        <h3 className={`text-lg font-bold text-neutral-500 ${classNameLabel}`}>
          {label}
        </h3>
        <span
          className={`px-2 py-0.5 text-sm font-medium text-center bg-amber-200 rounded-md text-zinc-800 ${classNameValue}`}
        >
          {value}
        </span>
      </div>
    </article>
  );
}
